<template>
  <div class="add_apply">
    <div class="bx_item">
      <div class="fs-40">服务说明</div>
      <div class="box fs-28 rich-text" v-html="instype_explain"></div>
    </div>
    <template v-if="is_new == 1">
      <div class="bx_item">
        <div class="fs-40 mt-50">
          设备正面照<span style="color: #e86161">*</span>
        </div>
        <div class="box fs-28">
          <p>1.{{ '请在拨号界面输入*#06#串码或序列号界面拍照；' }}</p>
          <p>2.请参考示例图拍摄，确保手机拍摄完整，串码一致</p>
        </div>
      </div>
      <pic-uploader @change="(url) => (formData.tem_img = url)" style="padding-left: 15px"
        :example="require(`@/assets/images/examplePic/example18.png`)" :src="formData.tem_img"></pic-uploader>
    </template>


    <!-- *****表单区****** -->
    <div class="bx_item form_box">
      <div class="fs-40 mt-50">
        用户信息<span style="color: #e86161">*</span>
      </div>
      <div>
        <van-form validate-first class="form_wid">
          <select-search-cell :disabled="phoneAndImeiDisabled" title="选择新机或存量机" :placeholder="'请选择新机或存量机'"
            v-model="is_new" :options="selectTypeList" id-key="value" label-key="name"></select-search-cell>
          <div>

            <!-- 顾客手机 -->
            <van-field class="form_wid" type="tel" v-model="formData.phone" label="手机号码" maxlength="11"
              placeholder="请输入11位机主手机号" :disabled="phoneAndImeiDisabled" />
          </div>

          <!-- IMEI号 -->
          <van-field label="IMEI号" maxlength="24" v-model="formData.imei" placeholder="输入IMEI码进行查询"
            :disabled="phoneAndImeiDisabled">
            <template #button>
              <van-button size="small" type="primary" @click="get3023()">查询</van-button>
            </template>
          </van-field>

          <select-search-cell :disabled="!phoneAndImeiDisabled" title="新机品牌"
            :placeholder="!phoneAndImeiDisabled ? '请先输入IMEI码进行查询' : '请选择'" v-model="formData.brandYd"
            :options="selectList.columns2" id-key="brandYd" label-key="brandYd" @change="($event) => {
              setSelectValue($event, 'brandYd');
            }
            "></select-search-cell>

          <select-search-cell :disabled="!phoneAndImeiDisabled" title="手机型号"
            :placeholder="!phoneAndImeiDisabled ? '请先输入IMEI码进行查询' : '请选择'" v-model="formData.modelYd"
            :options="selectList.columns3" id-key="modelYd" label-key="modelYd" @change="($event) => {
              setSelectValue($event, 'modelYd');
            }
            "></select-search-cell>


          <select-search-cell :disabled="!phoneAndImeiDisabled" title="手机规格"
            :placeholder="!phoneAndImeiDisabled ? '请先输入IMEI码进行查询' : '请选择'" v-model="formData.ramlYd"
            :options="selectList.columns4" id-key="ramlYd" label-key="ramlYd"></select-search-cell>


          <div style="display: flex;align-items: center;">
            <van-field :disabled="!phoneAndImeiDisabled" class="form_wid" type="text" v-model="formData.card_secret"
              label="保卡卡密" label-width="15em" placeholder="请输入6-12位保卡卡密">
              <template #button>
                <span @click="getCard()" style="color: #577BB5;">获取卡密</span>
              </template>
            </van-field>
          </div>

          <div class="access g-flex-ac g-flex-jc mt-20 mt-50">
            <img @click="protocol = true" v-if="protocol === false" src="../../assets/images/icon_gx_wx.png" alt="" />
            <img @click="protocol = false" v-if="protocol === true" src="../../assets/images/icon_gx.png" alt="" />
            <span class="ml-10" style="color: #999999">已阅读并接受</span>
            <span style="color: #577bb5" @click="clickProtocol">
              <span v-if="instype_name || this.showName.instype_name">《{{ this.showName.instype_name }}》</span>
              <span v-else>《碎屏服务》</span>
            </span>
          </div>
          <div class="btn_sub">
            <my-button class="confirm-btn" :type="protocol && status != 2 ? 'primary' : 'default'"
              :disabled="!protocol && status == 2" @click="onSubmit()">提交申请
            </my-button>
          </div>
        </van-form>
      </div>
    </div>
    <van-popup round v-model="showText">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="wra_tittle" v-if="this.showName.instype_name">
            {{ this.showName.instype_name }}服务协议
          </div>
          <div class="wra_tittle" v-else>碎屏服务协议</div>
          <div class="text rich-text" v-html="decodeHTML(instype_agree)"></div>
          <div class="wra_btn" @click="showText = false">知道了</div>
        </div>
      </div>
    </van-popup>
    <van-popup round v-model="toUrlShow" style="width: 60%;">
      <div style="margin: 20px 0;display: flex;justify-content: center;">{{ msg }} </div>
      <div class="torul_btn">
        <span v-if="urlLoading">请等待...</span>
        <span v-else @click="toUrl()">跳转</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { decodeHTML } from "@/common/filters";
import { get3023Model, queryNewOld2 } from "@/api";

import wx, { verification } from '@/utils/wxPermissionValidation'

export default {
  computed: {
    decodeHTML() {
      return (str) => {
        return decodeHTML(str);
      };
    },
  },
  data() {
    return {
      urlLoading: false,
      instype_name: "",
      showText: false,
      protocol: false, //协议阅读
      instype_agree:
        "1、为了您的手机提供全方面保障服务，当您的手机发生意外或想换机时，请根据理赔需求至理赔申请界面提交理赔申请;2、本服务仅针对购买/激活日期未超过7天的安卓新机，有过拆修、进水历史的机器禁止投保。", //协议详情内容
      instype_explain:
        "<p>1.为您的设备提供保障服务，请根据理赔需求至申请界面提交理赔申请；</p>" +
        "<p>2.本服务仅针对购买/激活日期未超过7天的新设备；</p>" +
        "<p>3.有过拆修、进水历史的、展示机禁止注册相应服务；</p>", //保险说明
      selectTypeList: [
        {
          name: '新机',
          value: 1
        },
        {
          name: '存量机',
          value: 0
        },
      ],
      selectList: {
        columns2: [], //手机品牌数组
        columns3: [], //手机型号数组
        columns4: [], //手机规格数组
      },
      //展示的下拉回显name
      showName: {
        instype_name: "", //权益类型（下拉输入框展示值）
        gear: "", // 档位（下拉输入框展示值）
        instype_id: "", //权益类型（下拉输入框展示值）
        brand: "", //品牌
        model_name: "", //品牌下型号
        ram_size: "", //规格
        net_name: "", //网络制式
        id_card_type: "大陆身份证", //身份证类型
      },

      formData: {
        imei: '',
        card_secret: '',
        tem_img: ''
      },
      phoneAndImeiDisabled: false,
      is_new: 3,
      status: 0,
      toUrlShow: false,
      url: '',
      msg: '',
      isSearchClick: 0
    };
  },
  watch: {

  },
  mounted() {
    this.getPhoneBrand()
    this.$http.insuranceTypeYidong().then((res) => {
      const { instype_agree, instype_explain } = res.data[0]
      this.instype_agree = instype_agree
      this.instype_explain = instype_explain
      this.showName = res.data[0]
    });
    const { order_id } = this.$route.query
    if (order_id) {
      this.$http.geYidOrderYidong({ order_id }).then((res) => {
        const { brandYd, modelYd } = res.data.order
        this.$http.getPhoneModelYidong({ brandYd }).then((res) => {
          this.selectList.columns3 = res.data;
        });
        this.$http.getPhoneRamYidong({ brandYd, modelYd }).then((res) => {
          this.selectList.columns4 = res.data;
        });
        this.formData = res.data.order
        this.is_new = res.data.order.is_new
      })
    }
  },
  methods: {
    getPhoneBrand() {
      this.$http.getPhoneBrandYidong().then((res) => {
        this.selectList.columns2 = res.data;
      });
    },
    setSelectValue(event, type) {
      console.log('event,type', event, type);
      if (type == 'brandYd') {
        const { brandYd } = event
        this.$http.getPhoneModelYidong({ brandYd }).then((res) => {
          this.selectList.columns3 = res.data;
        });
      }
      if (type == 'modelYd') {
        const { modelYd } = event
        const { brandYd } = this.formData
        this.$http.getPhoneRamYidong({ brandYd, modelYd }).then((res) => {
          this.selectList.columns4 = res.data;
        });
      }
    },
    get3023() {
      if (this.is_new == 1) {
        get3023Model({ imei: this.formData.imei }).then(res => {
          this.phoneAndImeiDisabled = true
          Toast(res.msg);
          const { brandYd, modelYd } = res.data
          this.$http.getPhoneModelYidong({ brandYd }).then((res) => {
            this.selectList.columns3 = res.data;
          });
          this.$http.getPhoneRamYidong({ brandYd, modelYd }).then((res) => {
            this.selectList.columns4 = res.data;
          });
          this.formData = {
            ...this.formData,
            ...res.data
          }
        })
      } else {
        //存量机
        queryNewOld2({ imei: this.formData.imei, phone: this.formData.phone }).then(res => {
          const { status, url } = res.data
          const { msg } = res
          this.status = status
          if (status == 1) {
            Toast(msg)
            this.phoneAndImeiDisabled = true
            this.isSearchClick = 1
            get3023Model({ imei: this.formData.imei }).then(res => {
              Toast(res.msg);
              const { brandYd, modelYd } = res.data
              this.$http.getPhoneModelYidong({ brandYd }).then((res) => {
                this.selectList.columns3 = res.data;
              });
              this.$http.getPhoneRamYidong({ brandYd, modelYd }).then((res) => {
                this.selectList.columns4 = res.data;
              });
              this.formData = {
                ...this.formData,
                ...res.data
              }
            })
          } else if (status == 3) {
            this.toUrlShow = true
            this.urlLoading = true
            setTimeout(() => {
              this.urlLoading = false
              this.toUrl()
            }, 3000);
            this.url = url
            this.msg = msg
          } else {
            Toast(msg)

          }
        })
      }




    },
    toUrl() {
      console.log('url', this.url);
      const targetUrl = this.url
      // 核心：重定向到目标链接
      window.location.href = targetUrl;
      // this.$router.push(this.url);
    },
    getCard() {
      const { brandYd, modelYd, ramlYd } = this.formData
      this.$http.getCardYidong({ brandYd, modelYd, ramlYd, is_new: this.is_new }).then((res) => {
        this.formData.card_secret = res.data.card_secret
        console.log('res.data.card_secret', res.data.card_secret);
        Toast(res.msg);

      });
    },
    clickProtocol() {
      this.showText = true;
      console.log(this.instype_agree);
    },
    onSubmit() {
      console.log('this.formData', this.formData);
      const {
        imei,
        card_secret,
        brandYd,
        modelYd,
        ramlYd,
        phone,
        tem_img,
        order_id
      } = this.formData
      let saveObj = {
        imei,
        card_secret,
        brandYd,
        modelYd,
        ramlYd,
        phone,
        tem_img,
        is_img: 0,
        is_new: this.is_new
      }
      console.log('saveObj', saveObj);

      if (order_id) {
        this.$http.editOrderYidong({ order_id, ...saveObj }).then((res) => {
          Toast(res.msg);
          if (res.code == 1) {
            this.$router.push({
              path: "/home",
            });
          }
        });
      } else {
        this.$http.yidongSetOrder({ isSearchClick: this.isSearchClick, ...saveObj }).then((res) => {
          Toast(res.msg);
          console.log('新增11：',res);
          
          if (res.code == 1) {
            const data = res.data;
            if(data.pay === 1){
              this.toWxPay(data.data);
            } else {
              this.$router.push({
                path: "/home",
              });
            }
          }
        });
      }
    },
    // 进行微信支付
    async toWxPay(data){
      await verification(["chooseWXPay"]); // 获取授权
      wx.chooseWXPay({
        timestamp: data.timeStamp,
        nonceStr: data.nonceStr,
        package: data.package,
        signType: data.signType,
        paySign: data.paySign,
        success: (result) => {
          Toast({
            title: result?.msg || "支付成功",
          });
          setTimeout(() => {
            this.$router.push({
              path: "/home",
            });
          }, 1000);
        },
        fail: (err) => {
          console.log(err)
        }
      })
    }
  },
};
</script>

<style scoped lang="less">
.random_carmi {
  color: rgb(87, 123, 181);
  font-size: 28px;
  width: 140px;
}

::v-deep .van-cell__title {
  flex: 0 3rem;
}

.add_apply {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 90vw;
    min-height: 30vh;
    max-height: 90vh;
    overflow-y: auto;
    background-color: #f6f8fe;
    border-radius: 20px;

    .wra_tittle {
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #323234;
      line-height: 60px;
      width: 90vw;
      margin: 20px auto;
      text-align: center;
    }

    div:nth-child(2) {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      max-height: 70vh;
      overflow-y: scroll;
      width: 80vw;
      margin: 0 auto;
      color: #333333;
      line-height: 44px;
    }

    .wra_btn {
      width: 400px;
      height: 80px;
      background: #577bb5;
      box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.3);
      border-radius: 40px;
      text-align: center;
      color: white;
      line-height: 80px;
      margin: 30px auto;
    }
  }

  .torul_btn {
    width: 400px;
    height: 80px;
    background: #577bb5;
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.3);
    border-radius: 40px;
    text-align: center;
    color: white;
    line-height: 80px;
    margin: 30px auto;
  }

  .beforeBtn {
    background: #1989fa;
    border: 1px solid #1989fa;
  }

  .afterBtn {
    background: #f0f0f0;
    border: 1px solid #f0f0f0;
    color: #999999;
  }

  ._price {
    /deep/ .van-field__control {
      color: #e86161;
    }
  }

  .img_seach {
    img {
      width: 40px;
    }
  }

  .access {
    text-align: center;
    height: 30px;
    line-height: 30px;

    img {
      width: 28px;
      height: 28px;
    }
  }

  .btn_sub {
    padding: 50px 0;
  }

  .bx_item {
    width: calc(100vw - 60px);
    margin: 20px auto;

    .box {
      line-height: 44px;
      margin-top: 20px;
      padding: 28px 25px;
      background: #f6f8fe;
      border-radius: 16px;
      color: #333333;
      font-family: PingFang SC;
      font-weight: 400;
    }
  }

  .uploder_img {
    height: 332px;
    border: 1px solid red;
  }
}

.not-purchased-from-our-shop {
  .van-cell__title {
    min-width: 8em;
  }
}

.van-switch {
  width: 2.1em;
}

.confirm-btn {
  width: calc(100vw - 150px);
  margin: 30px auto 0;
}

::v-deep .rich-text img {
  max-width: 100%;
}

.videoStyle {
  display: flex;
  justify-content: center;
  margin-bottom: 2em;
}
</style>
